import React from 'react';
import Svg, { Path } from 'react-native-svg';
import PropTypes from 'prop-types';

const QRCodeIcon = ({ color = '#000', size = 24 }) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M3 11h8V3H3v8zm0 10h8v-8H3v8zM13 3v8h8V3h-8zm6 18h2v-2h-2v2zm-6-8h2v-2h-2v2zm2 0h2v-2h-2v2zm-2 2h2v-2h-2v2zm2 0h2v-2h-2v2zm0 2h2v-2h-2v2zm2 0h2v-2h-2v2zm0 2h2v-2h-2v2zm2-4h2v-2h-2v2zm0 2h2v-2h-2v2zM5 5h4v4H5V5zm0 10h4v4H5v-4zM15 5h4v4h-4V5z"
        fill={color}
      />
    </Svg>
  );
};

QRCodeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

export default QRCodeIcon;
